/**
 * @generated SignedSource<<7c3e3a5a13c31686a29915eaba168ede>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ManageVaultFieldsOption_node$data = {
  readonly __typename: "Vault";
  readonly canUpdate?: {
    readonly value: boolean;
  };
  readonly id: string;
  readonly " $fragmentType": "ManageVaultFieldsOption_node";
};
export type ManageVaultFieldsOption_node$key = {
  readonly " $data"?: ManageVaultFieldsOption_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"ManageVaultFieldsOption_node">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ManageVaultFieldsOption_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Vault",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "b3e132b72dfe08eb88d66b3aa091f082";

export default node;
